export const IMSI_NOT_VALID_ERROR = 'IMSI_NOT_VALID';

export class ImsiNotValid extends Error {
  constructor() {
    super(IMSI_NOT_VALID_ERROR);
    this.name = IMSI_NOT_VALID_ERROR;
  }
}
